/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Material
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';

// Actions
import * as FacialActions from 'store/ducks/facial/actions';

// Types
import { ApplicationState } from 'store';

// Constants
import FACIAL from 'constants/facial';

// Styles
import useStyles from './validationStatusFilter.styles';

const ValidationStatusFilter: React.FC = () => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const filteredValidationStatus = useSelector(
    (state: ApplicationState) => state.facial.selectedValidationStatus,
  );

  const handleStatus = (status: number) => {
    const updated = [...filteredValidationStatus];
    const index = filteredValidationStatus.findIndex((e) => e === status);

    if (index === -1) {
      updated.push(status);
    } else updated.splice(index, 1);

    dispatch(
      FacialActions.setSelectedValidationStatus({
        selectedValidationStatus: updated,
      }),
    );
  };

  return (
    <List dense>
      {Object.values(FACIAL.VALIDATION_STATUS_FILTER).map((item) => (
        <ListItem key={item.LABEL} button>
          <ListItemText
            id={item.LABEL}
            primary={item.LABEL}
            onClick={() => handleStatus(item.VALUE)}
            classes={{ root: classes.itemText }}
          />
          <ListItemSecondaryAction>
            <Checkbox
              edge='end'
              name={item.LABEL}
              color='primary'
              onClick={() => handleStatus(item.VALUE)}
              checked={filteredValidationStatus.includes(item.VALUE)}
              inputProps={{ 'aria-labelledby': item.LABEL }}
            />
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
};

export { ValidationStatusFilter };
export default ValidationStatusFilter;
